(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyra-glow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const thumb=event.target.closest('[data-thumb]');if(thumb){const root=thumb.closest('[data-veyra]');root.querySelectorAll('[data-photo]').forEach(photo=>{photo.hidden=photo.dataset.photo!==thumb.dataset.thumb});root.querySelectorAll('[data-thumb]').forEach(button=>button.setAttribute('aria-pressed',String(button===thumb)))}const step=event.target.closest('[data-quantity]');if(step){const input=step.parentElement.querySelector('input');input.value=Math.max(1,(parseInt(input.value,10)||1)+Number(step.dataset.quantity));input.dispatchEvent(new Event('change',{bubbles:true}))}});

  } catch(e) { console.error(e); }
})();
})();
